// @flow
import client from '../../client'

// API Endpoint
export const CREATE_RATING = '/data-entry/ratings/external/'

/**
 * Create a rating for given provider and reservation
 * @param {Object} data Rating data
 * @param {Object} data.score User score from 0 to 5
 * @param {Object} data.description Some comment from the user
 * @param {Object} data.rating_token Id of reservation
 * @return {Promise|Error}
 */
export const createRating = (data: {
  score: string,
  description: string,
  rating_token: string,
}): Promise<any> => client.post(CREATE_RATING, { body: data })

export default createRating
